import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

// Miniatura de una foto del modelo con su boton para subir otra.
//   tipo "modelo": la foto del articulo (la de los PDF y Excel) -> /upprofile
//   tipo "fit":    la foto de fit (la muestra puesta)           -> /upfotofit
// La foto es del articulo: si el mismo modelo sale en varios renglones, todos
// comparten la misma. onSubida(url) avisa la url nueva.
// urlFoto trae "No" cuando no hay foto: solo cuenta si es una url.
const esUrl = (u) => /^https?:\/\//.test(u || "");
const sinImagen = () => `${process.env.PUBLIC_URL}/sinImagen.png`;

export function FotoArticulo({ idArticulo, url, tipo = "modelo", onSubida, tam = 80, compacto = false, ingles = false }) {
  const [subiendo, setSubiendo] = useState(false);
  const [version, setVersion] = useState(0);
  const tiene = esUrl(url);
  const t = ingles
    ? { subir: tipo === "fit" ? "Upload fit" : "Upload photo", cambiar: "Change", subiendo: "Uploading...", noImagen: "Choose an image file (jpg or png).", error: "Could not upload the photo" }
    : { subir: tipo === "fit" ? "Subir fit" : "Subir foto", cambiar: "Cambiar", subiendo: "Subiendo...", noImagen: "Elige un archivo de imagen (jpg o png).", error: "No se pudo subir la foto" };

  async function sube(archivo) {
    if (!archivo) return;
    if (!/^image\//.test(archivo.type)) {
      Swal.fire({ icon: "warning", title: ingles ? "Not an image" : "No es una imagen", text: t.noImagen });
      return;
    }
    setSubiendo(true);
    try {
      const fd = new FormData();
      fd.append("file", archivo);
      fd.append("articulo", idArticulo);
      const destino = tipo === "fit" ? process.env.REACT_APP_URL_UPFOTOFIT : process.env.REACT_APP_URL_UPPROFILE;
      const r = await axios.post(destino, fd, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } });
      const nueva = r.data?.secure_url;
      if (!nueva) throw new Error(r.data?.message || "Cloudinary no regreso la foto");
      setVersion(Date.now());
      if (onSubida) onSubida(nueva);
    } catch (error) {
      Swal.fire({ icon: "error", title: t.error, text: error.response?.data?.message || error.message });
    }
    setSubiendo(false);
  }

  const src = tiene ? `${url}${version ? `?v=${version}` : ""}` : sinImagen();
  return (
    <div style={{ display: "flex", flexDirection: compacto ? "row" : "column", alignItems: "center", gap: 4 }}>
      <a href={tiene ? url : undefined} target="_blank" rel="noopener noreferrer" title={tiene ? (ingles ? "Open photo" : "Ver la foto") : undefined}>
        <img alt={tipo}
          src={src}
          onError={(e) => { if (!e.currentTarget.src.endsWith("/sinImagen.png")) e.currentTarget.src = sinImagen(); }}
          style={{ width: tam, height: tam, objectFit: "cover", borderRadius: 6, border: "1px solid #e2e8f0", opacity: tiene ? 1 : 0.6 }} />
      </a>
      <label className={`btn btn-sm ${tiene ? "btn-outline-info" : "btn-info"}`}
        style={{ margin: 0, padding: "1px 8px", fontSize: 11, cursor: subiendo ? "wait" : "pointer", whiteSpace: "nowrap" }}>
        <i className="fas fa-camera" /> {subiendo ? t.subiendo : tiene ? t.cambiar : t.subir}
        <input type="file" accept="image/*" style={{ display: "none" }} disabled={subiendo}
          onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; sube(f); }} />
      </label>
    </div>
  );
}

export default FotoArticulo;
